// @ts-nocheck
import {
  Alert, Box, Typography, Link,
} from '@mui/material';
import React, { useState } from 'react';
import XLSXform8WastesTransportersExample from '../../../../../assets/files/KO_template_import_wastes_transporters.xlsx';
import { getReferencesRequest } from '../../../../../api/referenceApi';
import { getSubjectsRequest, updateSubjectRequest } from '../../../../../api/subjectApi';
import {
  FORM8_PLACING_OBJECTS_NAME,
  OBJECT_SUBJECT_RELATIONSHIPS_NAME,
  getInitialObjectSubjectRelationship,
} from '../../../../../constants/lkCadastr/cadastrForm8';
import {
  fitContent, flexGap2, flexRowGap2, fullWidth,
} from '../../../../../constants/lkCadastr/cadastrStorage';
import { OKTMOS_URL } from '../../../../../constants/urls';
import { deleteForm8Entity, getReportPlacingWasteHelper } from '../../../../../helpers/cadastreForms/form8Helper';
import { getOktmoLabel } from '../../../../../helpers/stringHelper';
import useCadastreTabs from '../../../../../hooks/useCadastreTabs';
import { AsyncAutocomplete } from '../../../../AutoCompletes/AsyncAutocomplete';
import AddButton from '../../../../Buttons/AddButton';
import DeleteButton from '../../../../Buttons/DeleteButton';
import CustomDatePicker from '../../../../CustomDatePicker';
import CustomInput from '../../../../Inputs';
import { DEFAULT_AUTOCOMPLETE_FIELD } from '../../../../Inputs/CustomAutocomplete';
import NavTabs from '../../../../Tabs';
import { Text, TextTitle } from '../../../../Text';
import ModalAddOktmo from '../../../ModalAddOktmo';
import { compareId } from '../../../../../helpers';
import BackdropLoading from '../../../../BackdropLoading';
import ModalWithTitle from '../../../ModalWithTitle';
import DropZone from '../../../../File/DropZone';
import { useApi } from '../../../../../hooks';
import CustomButton from '../../../../Buttons/CustomButton';
import { cadastreReportHistoryRequest, cadastreReportTechnologiesImportRequest } from '../../../../../api/cadastreApi';
import { METHODS_API } from '../../../../../api/api';

export function WasteTransporters({
  placingObject,
  changeObject,
  isDemo,
  reportId,
  setCreateSubjectField,
  placingObjectField,
  openDeleteModal,
  changeItemFormByField,
}) {
  const objectSubjectRelationships = placingObject[OBJECT_SUBJECT_RELATIONSHIPS_NAME];
  const [oktmoInfo, setOktmoInfo] = useState(null);
  const [openedImport, setOpenedImport] = useState(false);

  const openImportModal = () => setOpenedImport(true);
  const closeImportModal = () => setOpenedImport(false);

  const getFiles = async (dropZoneFiles) => {
    const formData = new FormData();

    formData.append('import[file]', dropZoneFiles[0]);
    formData.append('import[format_type]', 'xlsx');
    formData.append('import[kind]', 'report_object_legal_person');

    await cadastreReportTechnologiesImportRequest({
      method: METHODS_API.POST,
      data: formData,
      rest: `?report_history_id=${reportId}&placed_object_id=${placingObject?.id}`,
      isFormData: true,
    });

    const newReport = await cadastreReportHistoryRequest({
      method: METHODS_API.GET,
      id: reportId,
    });

    const reportPlacingWaste = await getReportPlacingWasteHelper(newReport);

    changeItemFormByField({
      field: `form8.${FORM8_PLACING_OBJECTS_NAME}`, value: [...reportPlacingWaste.placing_objects], type: 'import',
    });

    closeImportModal();
  };

  const { defaultRequest: importFromFile, isLoading: loadingImport } = useApi({ request: getFiles });

  const { tab, setTab, tabs } = useCadastreTabs({ items: objectSubjectRelationships, tabName: 'Юридическое лицо' });

  const closeOktmoModal = () => setOktmoInfo(null);

  const setNewOktmo = async ({ oktmo, subject, field }) => {
    await updateSubjectRequest(subject?.id, { oktmo: getOktmoLabel(oktmo) });
    changeObject(field, {
      ...subject,
      oktmo: getOktmoLabel(oktmo),
    });
    closeOktmoModal();
  };

  const modalOktmo = (
    <ModalAddOktmo
      close={closeOktmoModal}
      setNewOktmo={(newOktmo) => setNewOktmo({
        oktmo: newOktmo,
        subject: oktmoInfo.subject,
        field: oktmoInfo.field,
      })}
      isOpen
    />
  );

  return (
    <Box sx={flexGap2}>
      {oktmoInfo !== null && modalOktmo}
      <Box sx={flexRowGap2}>
        <TextTitle h3>
          Наименование юридического лица
          (ФИО индивидуального предпринимателя),
          транспортирующего отходы на объект
        </TextTitle>
        {!isDemo && (
          <AddButton
            variant="outlined"
            onClick={() => changeObject(
              OBJECT_SUBJECT_RELATIONSHIPS_NAME,
              [...objectSubjectRelationships, getInitialObjectSubjectRelationship()],
            )}
          >
            Добавить юридическое лицо
          </AddButton>
        )}
      </Box>
      <BackdropLoading position="fixed" isLoading={loadingImport} />
      {!isDemo && <CustomButton onClick={openImportModal} disabled={!placingObject?.id}>Импортировать из файла</CustomButton>}
      {!isDemo && !placingObject?.id && (
        <Typography>* Для импорта сохраните форму</Typography>
      )}
      {openedImport && (
        <ModalWithTitle open close={closeImportModal} title="Импортировать из файла">
          <Alert severity="warning" sx={{ mb: 2 }}>
            Загруженный файл должен быть формате Office Excel до 20 Мб, содержать не более 1000 строк. В файле должны содержаться наименование (ФИО), ИНН, адрес и количество отходов.
            <Link sx={{ ml: 1 }} href={XLSXform8WastesTransportersExample}>Скачать пример файла импорта</Link>
          </Alert>
          <DropZone sx={{ height: 120 }} getFiles={(e, files) => importFromFile(files)} maxFiles={1} />
        </ModalWithTitle>
      )}
      <NavTabs tab={tab} setTab={setTab} tabsComponents={tabs} />
      {objectSubjectRelationships.map((objectSubjectRelationship, objectSubjectRelationshipIndex) => {
        if (tab !== objectSubjectRelationship.randId) return null;

        const onChange = (field, value) => {
          changeObject(`${OBJECT_SUBJECT_RELATIONSHIPS_NAME}.${objectSubjectRelationshipIndex}.${field}`, value, undefined, { objectSubjectRelationshipIndex });
        };

        const onDelete = async () => {
          if (objectSubjectRelationship.id) {
            await deleteForm8Entity({
              id: objectSubjectRelationship.id,
              apiType: OBJECT_SUBJECT_RELATIONSHIPS_NAME,
            });
          }

          const cloneArray = objectSubjectRelationships.slice();
          cloneArray.splice(objectSubjectRelationshipIndex, 1);

          changeObject(
            OBJECT_SUBJECT_RELATIONSHIPS_NAME,
            cloneArray,
            'delete',
          );
        };

        const isZeroSubject = compareId(objectSubjectRelationship.subject_id?.name, 0);

        return (
          <Box key={objectSubjectRelationship.randId} sx={flexGap2}>
            {!isDemo && objectSubjectRelationships.length > 1 && (
              <DeleteButton
                onClick={() => openDeleteModal(onDelete, objectSubjectRelationshipIndex, 'Юридическое лицо')}
              >
                Удалить юридическое лицо
              </DeleteButton>
            )}
            <Box sx={flexGap2}>
              <Alert severity="info">
                Для поиска организации в справочнике введите наименование или ИНН в графу «Наименование юридического лица (ФИО индивидуального предпринимателя), транспортирующего отходы на объект»,  в случае отсутствия нажмите кнопку «+Создать субъект» и добавьте организацию в справочник.
              </Alert>
              <Box>
                <Text className="mute">Наименование или ФИО</Text>
                <AsyncAutocomplete
                  canBeZero
                  validImmediately={!isZeroSubject}
                  debounceTime={0}
                  disabled={isDemo}
                  request={(params) => getSubjectsRequest({ params })}
                  sx={fullWidth}
                  noOptionComponent={(
                    <AddButton
                      variant="outlined"
                      onClick={() => setCreateSubjectField({
                        field: `${placingObjectField}.${OBJECT_SUBJECT_RELATIONSHIPS_NAME}.${objectSubjectRelationshipIndex}.subject_id`,
                        objectSubjectRelationshipIndex,
                      })}
                    >
                      Создать субъект
                    </AddButton>
                  )}
                  value={objectSubjectRelationship.subject_id}
                  onChange={(e, value) => onChange('subject_id', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Фактический адрес</Text>
                <CustomInput
                  disabled
                  multiline
                  sx={fullWidth}
                  value={objectSubjectRelationship.subject_id?.actual_address}
                />
              </Box>
              <Box>
                <Text className="mute">Адрес регистрации</Text>
                <CustomInput
                  disabled
                  multiline
                  sx={fullWidth}
                  value={objectSubjectRelationship.subject_id?.registry_address}
                />
              </Box>
              <Box>
                <Text className="mute">ОКТМО</Text>
                <AsyncAutocomplete
                  debounceTime={0}
                  validImmediately={!(!objectSubjectRelationship?.subject_id?.id || objectSubjectRelationship?.subject_id?.oktmo || isZeroSubject)}
                  disabled={!objectSubjectRelationship?.subject_id?.id || objectSubjectRelationship?.subject_id?.oktmo || isZeroSubject}
                  optionField={DEFAULT_AUTOCOMPLETE_FIELD}
                  stringValue={objectSubjectRelationship?.subject_id?.oktmo}
                  onChange={(e, value) => setNewOktmo({
                    oktmo: value,
                    subject: objectSubjectRelationship?.subject_id,
                    field: `${OBJECT_SUBJECT_RELATIONSHIPS_NAME}.${objectSubjectRelationshipIndex}.subject_id`,
                  })}
                  noOptionComponent={(
                    <AddButton
                      onClick={() => setOktmoInfo({
                        field: `${OBJECT_SUBJECT_RELATIONSHIPS_NAME}.${objectSubjectRelationshipIndex}.subject_id`,
                        subject: objectSubjectRelationship?.subject_id,
                      })}
                      variant="outlined"
                    >
                      Добавить ОКТМО
                    </AddButton>
                  )}
                  additionalFilter={(options) => options.map((option) => ({
                    ...option,
                    label: `${option.code} ${option.name}`,
                  }))}
                  request={(params) => getReferencesRequest({ url: OKTMOS_URL, params })}
                  sx={fullWidth}
                  containerSx={fullWidth}
                />
              </Box>
              <Box>
                <Text className="mute">ИНН</Text>
                <CustomInput
                  disabled
                  sx={fullWidth}
                  value={objectSubjectRelationship.subject_id?.inn}
                />
              </Box>
              <Box>
                <Text className="mute">Номер документа</Text>
                <CustomInput
                  canBeZero
                  debounceTime={0}
                  validImmediately
                  disabled={isDemo}
                  sx={fullWidth}
                  value={objectSubjectRelationship.agreement_number}
                  onChange={(e, value) => onChange('agreement_number', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Дата</Text>
                <CustomDatePicker
                  canBeZero
                  validImmediately
                  disabled={isDemo}
                  sx={fitContent}
                  value={objectSubjectRelationship.agreement_date}
                  onChange={(e, value) => onChange('agreement_date', value)}
                />
              </Box>
              <Box>
                <Text className="mute">Количество, т</Text>
                <CustomInput
                  canBeZero
                  debounceTime={0}
                  validImmediately
                  disabled={isDemo}
                  type="number"
                  sx={fullWidth}
                  value={objectSubjectRelationship.tons_qty}
                  onChange={(e, value) => onChange('tons_qty', value)}
                />
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
